import { useState } from "react";
import { useTranslation } from "react-i18next";

import { VacancyFormFactory } from "./form/VacancyFormFactory";
import { Alert } from "./Alert";
import { Loader } from "./Loader";
import { useGetVacancyForm } from "@hooks/useGetVacancyForm";
import type { VacancyApplyFormProps } from "../types/VacancyTypes";

export const VacancyApplyForm = ({
  formId,
  locale,
  applyFormSubmitted,
}: VacancyApplyFormProps) => {
  const { t } = useTranslation();
  const [formError, setFormError] = useState<string | null>(null);

  const {
    data: vacancyForm,
    isLoading,
    error,
  } = useGetVacancyForm(formId, { locale });

  return (
    <div data-testid="vacancy-apply-form">
      {isLoading && (
        <div className="flex min-h-80 items-center justify-center">
          <Loader />
        </div>
      )}

      {(formError || error) && (
        <div className="mb-4 flex items-center justify-center">
          <Alert
            variant="error"
            labelText={t("Vacancies.form.error.label")}
            text={formError ?? t("Vacancies.form.error.text")}
          />
        </div>
      )}

      {!isLoading && !error && vacancyForm && (
        <VacancyFormFactory
          formId={formId}
          locale={locale ?? "nl"}
          formFields={vacancyForm.fields}
          applyFormSubmitted={applyFormSubmitted}
          setFormError={setFormError}
        />
      )}
    </div>
  );
};
